var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('chat'),_c('nav-bar'),_c('div',{staticClass:"content"},[_c('router-view',{key:_vm.$route.fullPath})],1),(!['/login', '/reset', '/reg'].some(item => _vm.$route.path.includes(item)))?_c('foot-bar'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }